'use strict';

define('vb/action/builtin/exportLayoutAction',['vb/action/action',
  'vb/extensions/dynamic/private/types/abstractMetadataProviderDescriptor'],
(Action, AbstractMetadataProviderDescriptor) => {
  /* eslint-disable max-len */
  /** @typedef {import('vb/action/action').Outcome} Outcome */
  /** @typedef {import('vb/extensions/dynamic/private/types/bridges/helperMetadataProviderFactoryBridge').default} HelperMetadataProviderFactoryBridge */
  /* eslint-enable max-len */

  /**
   * Action class responsible for exporting a layout.
   * @extends Action
   * @category Action
   */
  class ExportLayoutAction extends Action {
    /**
     * Performs the export layout action.
     *
     * @async
     * @param {Object} parameters - The parameters for the action.
     * @param {AbstractMetadataProviderDescriptor} parameters.metadataDescriptor - The metadata descriptor to export
     * the layout from.
     * @returns {Promise<Outcome>} The outcome of the action, either a success with the exported layout or
     * a failure with an error message.
     */
    // eslint-disable-next-line class-methods-use-this
    async perform(parameters) {
      const {
        metadataDescriptor,
      } = parameters;

      try {
        if (!(metadataDescriptor instanceof AbstractMetadataProviderDescriptor)) {
          throw new Error('Layout can only be exported from a MetadataProviderDescriptor.');
        }

        const helperBridge = /** @type {HelperMetadataProviderFactoryBridge} */ (metadataDescriptor.bridge);
        const exportedLayout = helperBridge.helper.serializeLayout();
        return Action.createSuccessOutcome(exportedLayout);
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        return Action.createFailureOutcome(message, error);
      }
    }
  }

  return ExportLayoutAction;
});

